import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgBolt = function SvgBolt(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: 35,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M17.505 5.76c-4.466.009-8.076 3.642-8.09 8.138-.014 4.515 3.61 8.167 8.104 8.167 4.433 0 8.066-3.647 8.066-8.11 0-4.53-3.619-8.205-8.08-8.195Zm0 10.76c-1.426 0-2.584-1.161-2.593-2.608-.01-1.408 1.157-2.59 2.574-2.594a2.589 2.589 0 0 1 2.598 2.59c0 1.441-1.153 2.613-2.58 2.613ZM20.13 26.542c.015 1.58-1.204 2.684-2.616 2.698-1.421.015-2.659-1.162-2.645-2.717a2.635 2.635 0 0 1 2.622-2.613c1.468-.01 2.635 1.152 2.645 2.632h-.005Z",
      fill: "currentColor"
    }))
  }));
};
export default SvgBolt;